export const MappingIcruToName: Record<string, string> = {
	'1': 'H.txt',
	'2': 'He.txt',
	'3': 'Li.txt',
	'4': 'Be.txt',
	'5': 'B.txt',
	'6': 'C.txt',
	'7': 'N.txt',
	'8': 'O.txt',
	'9': 'F.txt',
	'10': 'Ne.txt',
	'11': 'Na.txt',
	'12': 'Mg.txt',
	'13': 'Al.txt',
	'14': 'Si.txt',
	'15': 'P.txt',
	'16': 'S.txt',
	'17': 'Cl.txt',
	'18': 'Ar.txt',
	'19': 'K.txt',
	'20': 'Ca.txt',
	'21': 'Sc.txt',
	'22': 'Ti.txt',
	'23': 'V.txt',
	'24': 'Cr.txt',
	'25': 'Mn.txt',
	'26': 'Fe.txt',
	'28': 'Ni.txt',
	'29': 'Cu.txt',
	'30': 'Zn.txt',
	'31': 'Ga.txt',
	'32': 'Ge.txt',
	'33': 'As.txt',
	'34': 'Se.txt',
	'35': 'Br.txt',
	'36': 'Kr.txt',
	'37': 'Rb.txt',
	'38': 'Sr.txt',
	'39': 'Y.txt',
	'40': 'Zr.txt',
	'41': 'Nb.txt',
	'42': 'Mo.txt',
	'43': 'Tc.txt',
	'44': 'Ru.txt',
	'45': 'Rh.txt',
	'46': 'Pd.txt',
	'47': 'Ag.txt',
	'48': 'Cd.txt',
	'49': 'In.txt',
	'50': 'Sn.txt',
	'51': 'Sb.txt',
	'52': 'Te.txt',
	'53': 'I.txt',
	'54': 'Xe.txt',
	'55': 'Cs.txt',
	'56': 'Ba.txt',
	'57': 'La.txt',
	'58': 'Ce.txt',
	'59': 'Pr.txt',
	'60': 'Nd.txt',
	'61': 'Pm.txt',
	'62': 'Sm.txt',
	'63': 'Eu.txt',
	'64': 'Gd.txt',
	'65': 'Tb.txt',
	'66': 'Dy.txt',
	'67': 'Ho.txt',
	'68': 'Er.txt',
	'69': 'Tm.txt',
	'70': 'Yb.txt',
	'71': 'Lu.txt',
	'72': 'Hf.txt',
	'73': 'Ta.txt',
	'74': 'W.txt',
	'75': 'Re.txt',
	'76': 'Os.txt',
	'77': 'Ir.txt',
	'78': 'Pt.txt',
	'79': 'Au.txt',
	'80': 'Hg.txt',
	'81': 'Tl.txt',
	'82': 'Pb.txt',
	'83': 'Bi.txt',
	'84': 'Po.txt',
	'85': 'At.txt',
	'86': 'Rn.txt',
	'87': 'Fr.txt',
	'88': 'Ra.txt',
	'89': 'Ac.txt',
	'90': 'Th.txt',
	'91': 'Pa.txt',
	'92': 'U.txt',
	'93': 'Np.txt',
	'94': 'Pu.txt',
	'95': 'Am.txt',
	'96': 'Cm.txt',
	'97': 'Bk.txt',
	'98': 'Cf.txt',
	'99': 'A-150.txt',
	'100': 'Acetone.txt',
	'101': 'Acetylene.txt',
	'102': 'Adenine.txt',
	'103': 'Adipose.txt',
	'104': 'Air.txt',
	'105': 'Alanine.txt',
	'106': 'Al2O3.txt',
	'107': 'Amber.txt',
	'108': 'Ammonia.txt',
	'109': 'Aniline.txt',
	'110': 'Anthracene.txt',
	'111': 'B-100.txt',
	'112': 'Bakelite.txt',
	'113': 'BaF2.txt',
	'114': 'BaSO4.txt',
	'115': 'Benzene.txt',
	'116': 'BeO.txt',
	'117': 'BiGeO.txt',
	'118': 'BloodICRP.txt',
	'119': 'BoneICRU.txt',
	'120': 'BoneICRP.txt',
	'121': 'B4C.txt',
	'122': 'BoronOxide.txt',
	'123': 'BrainICRP.txt',
	'124': 'Butane.txt',
	'125': 'N-ButylAlcohol.txt',
	'126': 'C-552.txt',
	'127': 'CdTe.txt',
	'128': 'CdWO4.txt',
	'129': 'CaCO3.txt',
	'130': 'CaF2.txt',
	'131': 'CaO.txt',
	'132': 'CaSO4.txt',
	'133': 'CaWO4.txt',
	'134': 'CO2.txt',
	'135': 'CCl4.txt',
	'136': 'Cellophane.txt',
	'137': 'CAB.txt',
	'138': 'CelNitrate.txt',
	'139': 'CeSO4Dos.txt',
	'140': 'CsF.txt',
	'141': 'CsI.txt',
	'142': 'ClBenzene.txt',
	'143': 'CHCl3.txt',
	'144': 'Concrete.txt',
	'145': 'Cyclohexane.txt',
	'146': 'DClBenzene.txt',
	'147': 'DClDEtyEth.txt',
	'148': 'DClEthane.txt',
	'149': 'DEtyEther.txt',
	'150': 'DMF.txt',
	'151': 'DMSO.txt',
	'152': 'C2H6.txt',
	'153': 'Ethanol.txt',
	'154': 'EthylCell.txt',
	'155': 'C2H4.txt',
	'156': 'Eyelens.txt',
	'157': 'Fe2O3.txt',
	'158': 'FeB.txt',
	'159': 'FeO.txt',
	'160': 'FeSO4Dos.txt',
	'161': 'Freon-12.txt',
	'162': 'Freon-12B2.txt',
	'163': 'Freon-13.txt',
	'164': 'Freon-13B1.txt',
	'165': 'Freon-13I1.txt',
	'166': 'GOS.txt',
	'167': 'GaAs.txt',
	'168': 'GelPhot.txt',
	'169': 'GlassPyrex.txt',
	'170': 'GlassLead.txt',
	'171': 'GlassPlate.txt',
	'172': 'Glucose.txt',
	'173': 'Glutamine.txt',
	'174': 'Glycerol.txt',
	'175': 'Guanine.txt',
	'176': 'Gypsum.txt',
	'177': 'Heptane.txt',
	'178': 'Hexane.txt',
	'179': 'Kapton.txt',
	'180': 'LaBrO.txt',
	'181': 'La2O2S.txt',
	'182': 'PbO.txt',
	'183': 'LiNH2.txt',
	'184': 'Li2CO3.txt',
	'185': 'LiF.txt',
	'186': 'LiH.txt',
	'187': 'LiI.txt',
	'188': 'Li2O.txt',
	'189': 'Li4borate.txt',
	'190': 'Lung.txt',
	'191': 'M3wax.txt',
	'192': 'MgCO3.txt',
	'193': 'MgF2.txt',
	'194': 'MgO.txt',
	'195': 'MgB4O7.txt',
	'196': 'HgI2.txt',
	'197': 'CH4.txt',
	'198': 'Methanol.txt',
	'199': 'MixDwax.txt',
	'200': 'MS20.txt',
	'201': 'MuscleICRP.txt',
	'202': 'MuscleICRU.txt',
	'203': 'MuscleSuc.txt',
	'204': 'MuscleNoSuc.txt',
	'205': 'Naphthalene.txt',
	'206': 'NitroBenz.txt',
	'207': 'N2O.txt',
	'208': 'Elvamide.txt',
	'209': 'Nylon.txt',
	'210': 'Nylon6-10.txt',
	'211': 'Rilsan.txt',
	'212': 'Octane.txt',
	'213': 'Paraffin.txt',
	'214': 'Pentane.txt',
	'215': 'Emulsion.txt',
	'216': 'Plasscin.txt',
	'217': 'PuO2.txt',
	'218': 'PAN.txt',
	'219': 'Polycarb.txt',
	'220': 'Polyclst.txt',
	'221': 'Polyeth.txt',
	'222': 'Mylar.txt',
	'223': 'Lucite.txt',
	'224': 'POM.txt',
	'225': 'PP.txt',
	'226': 'PS.txt',
	'227': 'Teflon.txt',
	'228': 'PTFCE.txt',
	'229': 'PVAc.txt',
	'230': 'PVOH.txt',
	'231': 'PVB.txt',
	'232': 'PVC.txt',
	'233': 'Saran.txt',
	'234': 'PVDF.txt',
	'235': 'PVP.txt',
	'236': 'KI.txt',
	'237': 'K2O.txt',
	'238': 'Propane.txt',
	'239': 'PropaneLiq.txt',
	'240': 'NPropylOH.txt',
	'241': 'Pyridine.txt',
	'242': 'RubberB.txt',
	'243': 'Rubber.txt',
	'244': 'Neoprene.txt',
	'245': 'SiO2.txt',
	'246': 'AgBr.txt',
	'247': 'AgCl.txt',
	'248': 'AgHaEmul.txt',
	'249': 'AgI.txt',
	'250': 'Skin.txt',
	'251': 'Na2CO3.txt',
	'252': 'NaI.txt',
	'253': 'Na2O.txt',
	'254': 'NaNO3.txt',
	'255': 'Stilbene.txt',
	'256': 'Sucrose.txt',
	'257': 'Terphenyl.txt',
	'258': 'Testes.txt',
	'259': 'C2Cl4.txt',
	'260': 'TlCl.txt',
	'261': 'TissueICRP.txt',
	'262': 'TissueICRU.txt',
	'263': 'Tissmeth.txt',
	'264': 'Tissprop.txt',
	'265': 'TiO2.txt',
	'266': 'Toluene.txt',
	'267': 'Trichlor.txt',
	'268': 'Triethphos.txt',
	'269': 'WF6.txt',
	'270': 'UC2.txt',
	'271': 'UC.txt',
	'272': 'UO.txt',
	'273': 'Urea.txt',
	'274': 'Valine.txt',
	'275': 'Viton.txt',
	'276': 'Water.txt',
	'277': 'H2Ovapor.txt',
	'278': 'Xylene.txt'
};
